import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BannerService } from './banner.service';
import { BannerBarComponent } from './banner-bar/banner-bar.component';
import { MatToolbarModule } from '@angular/material/toolbar';

@NgModule({
    providers: [BannerService],
    declarations: [BannerBarComponent],
    exports: [
        BannerBarComponent
    ],
    imports: [
        CommonModule,
        MatToolbarModule
    ]
})
export class ModerationModule {}
